import styled from "styled-components";
import GirlKidsLearning from "assets/images/jpgs/GirlKidsLearning.jpg";
import { useNavigate } from "react-router-dom";
import CheckBox from "shared/CheckBox";
import { TKIconLove, TKIconSaveProject } from "assets/images/svgs";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getDonationPerProject } from "appState/donation/donationSlice";
import MakeDonation from "layout/modal/MakeDonation";
import {
  addProjectToFavorite,
  removeProjectFromFavorite,
} from "appState/project/projectSlice";
import { getCurrentDonor } from "appState/auth/authSlice";

const Banner = ({ donateProp, project }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { donor, isAuthenticated } = useSelector((state) => state.auth);
  const { projectDonationsCount } = useSelector((state) => state.donation);

  const [selectedItems, setSelectedItems] = useState([]);
  const [showDonateModal, setshowDonateModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const themes = ["bg-[#FF8F41]", "bg-[#61CE70]", "bg-[#0693E3]"];

  useEffect(() => {
    project?._id && dispatch(getDonationPerProject({ id: project?._id }));
  }, [dispatch, project?._id]);

  const percentage = Number(
    Math.floor((project?.amountDonated / project?.fundraising_goal) * 100)
  );

  const width = `w-[${percentage}%]`;

  const theme = percentage % 3;

  const handleNavigate = () => {
    if (selectedItems.length === 0) {
      toast.error("No items selected");
      return;
    } else {
      const state = {
        project: { id: project?._id, name: project?.name },
        category: project?.project_category[0],
        items: selectedItems,
      };
      let path = "/donate-items/category/specific-project";
      navigate(path, { state: state });
    }
  };

  const handleSelect = (e) => {
    const { value, checked } = e.target;
    const newSelectedItems = [...selectedItems];

    if (checked) {
      setSelectedItems([...newSelectedItems, value]);
    } else {
      setSelectedItems(newSelectedItems.filter((item) => item !== value));
    }
  };

  const likeProject = () => {
    if (!donor || !isAuthenticated) {
      toast.error("Please login as a donor!");
      return;
    }
    dispatch(addProjectToFavorite({ id: project?._id })).then((data) => {
      if (data?.payload?.status === 200) {
        dispatch(getCurrentDonor());
      }
    });
  };

  const unlikeProject = () => {
    if (!donor || !isAuthenticated) {
      toast.error("Please login as a donor!");
      return;
    }
    dispatch(removeProjectFromFavorite({ id: project?._id })).then((data) => {
      if (data?.payload?.status === 200) {
        dispatch(getCurrentDonor());
      }
    });
  };

  return (
    <div>
      <MakeDonation
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        onClose={() => {
          setshowDonateModal(false);
          setCurrentStep(0);
        }}
        isOpen={showDonateModal}
        project
        projectId={project?._id}
        ngo={project?.ngo}
      />

      <div className="mt-[87px]">
        <BannerContainer />
        <div className="w-full flex flex-wrap justify-between items-center gap-2 bg-[#484848] py-2 px-16 max-[450px]:px-8">
          <div className="flex flex-wrap">
            <div
              className={`flex items-center text-white py-2 px-4 ${themes[theme]} uppercase`}
            >
              <p className="whitespace-nowrap text-[12px] pr-2">Project goal</p>
              <p className="font-medium text-[16px]">
                N{project?.fundraising_goal}
              </p>
            </div>
            <div className="flex min-w-[199px] items-center text-white py-2 px-4 bg-[#5C5C5C] uppercase">
              <p className="text-[12px] pr-2">Achieved</p>
              <p className="font-medium text-[16px]">
                N{project?.amountDonated}
              </p>
            </div>
          </div>
          <div className="w-2/5 flex justify-between items-center text-white gap-2">
            <div className="flex flex-col items-center">
              <p className="tracking-wider font-extrabold text-[45px]">
                {percentage}%
              </p>
              <p className="text-[12px] tracking-widest uppercase">
                of our goal
              </p>
            </div>
            <div className="flex flex-col items-center">
              <p className="tracking-wider font-extrabold text-[45px]">
                {projectDonationsCount}
              </p>
              <p className="text-[12px] tracking-widest uppercase">donations</p>
            </div>
            <div>
              <p
                onClick={() => setshowDonateModal(true)}
                className="rounded-full bg-white p-3 text-[#7A7A7A] text-[14px] whitespace-nowrap cursor-pointer border hover:font-medium hover:border-[#F57200]"
              >
                DONATE NOW
              </p>
            </div>
          </div>
        </div>
        <div className="px-16 max-[450px]:px-8 py-16 max-md:flex-wrap justify-center flex flex-col gap-6">
          <div className="w-full min-[530px]:h-[468px] flex max-[530px]:flex-col">
            <div className="w-[65%] flex flex-col max-[530px]:w-full max-[530px]:flex-col-reverse">
              <img
                className="w-full h-full object-cover"
                src={project?.project_picture}
                alt={project?.name}
              />
              <div className="bg-[#484848]">
                <div
                  className={`${width} ${themes[theme]} h-[14px] flex justify-center items-center text-[#7A7A7A] text-[12px] whitespace-nowrap`}
                >
                  {percentage}%...
                </div>
              </div>
            </div>
            <div
              className={`w-[35%] max-[530px]:h-[200px] max-[530px]:w-full ${themes[theme]} flex justify-center items-center p-4`}
            >
              <p className="text-white text-center text-[28px] font-extrabold p-4">
                {project?.impact_of_monetary_goal}
              </p>
            </div>
          </div>
          <div className="w-full max-[520px]:flex-col flex gap-2">
            <div
              className={`${
                !donateProp ? "w-[65%]" : "w-full"
              } max-[520px]:w-full flex flex-col`}
            >
              <div
                onClick={() => setshowDonateModal(true)}
                className="w-full bg-[#213874] flex items-center justify-center cursor-pointer hover:bg-[#2048ae]"
              >
                <p className="text-white py-1">Donate Money</p>
              </div>
              <div className="p-4 gap-2 my-4 bg-white">
                <div className="flex flex-wrap gap-2 justify-between items-center py-1 border-b">
                  <p className="font-bold text-[14px] text-[#213874] uppercase">
                    Project Summary
                  </p>
                  <div
                    onClick={() => {
                      if (
                        donor?.donor?.favourites?.find(({ _id }) =>
                          _id.includes(project?._id)
                        )
                      ) {
                        unlikeProject();
                      } else {
                        likeProject();
                      }
                    }}
                    className="flex items-center gap-1 cursor-pointer"
                  >
                    {donor?.donor?.favourites?.find(({ _id }) =>
                      _id.includes(project?._id)
                    ) ? (
                      <TKIconLove />
                    ) : (
                      <TKIconSaveProject />
                    )}
                    <p className="text-[#213874] text-[14px] hover:font-medium">
                      Save Project
                    </p>
                  </div>
                </div>
                <div className="flex flex-col my-2 gap-2">
                  <p className="leading-[18px] text-[16px] text-[#222222]">
                    {project?.summary}
                  </p>
                </div>
                <div className="flex justify-start items-center py-1 mt-4 border-b">
                  <p className="font-bold text-[#213874] text-[14px] uppercase">
                    IMPACT
                  </p>
                </div>
                <div className="flex flex-col my-2 gap-2">
                  <p className="leading-[18px] text-[16px] text-[#222222]">
                    {project?.impact_of_monetary_goal}
                  </p>
                  <p className="leading-[18px] text-[16px] text-[#222222]">
                    {project?.impact_of_donated_item}
                  </p>
                </div>
                <div className="flex justify-start items-center py-1 mt-4 border-b">
                  <p className="font-bold text-[#213874] text-[16px] uppercase">
                    ABOUT
                  </p>
                </div>
                <div className="flex flex-col my-2 gap-2">
                  <p className="leading-[18px] text-[16px] text-[#222222]">
                    Website - www.backtoscho.ng
                  </p>
                  <p className="leading-[18px] text-[16px] text-[#222222]">
                    Facebook -{" "}
                  </p>
                  <p className="leading-[18px] text-[16px] text-[#222222]">
                    Instagram -{" "}
                  </p>
                  <p className="leading-[18px] text-[16px] text-[#222222]">
                    Founder - Mr. Blackie
                  </p>
                </div>
              </div>
            </div>
            {!donateProp && (
              <div className={`w-[35%] max-[520px]:w-full`}>
                <div className="bg-white flex flex-col gap-3 px-4 py-2">
                  <div className="border-b pb-4">
                    <p className="font-bold text-[#213874] text-[14px]">
                      ITEMS NEEDED
                    </p>
                  </div>
                  <div>
                    <p className="text-[16px] capitalize">
                      {project?.impact_of_donated_item}
                    </p>
                  </div>
                  <div>
                    <p className="italic text-[#213874] text-[16px] font-semibold">
                      Select an item or items you would like to donate.
                    </p>
                  </div>
                  <div>
                    <div className="flex flex-col my-2">
                      {project?.items_donation?.map((item, index) => (
                        <div key={index} className="my-2">
                          <CheckBox
                            onChange={(e) => handleSelect(e)}
                            name={item?.item}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div
                  onClick={handleNavigate}
                  className="w-full bg-[#213874] flex items-center justify-center cursor-pointer hover:bg-[#2048ae]"
                >
                  <p className="text-white py-1">Donate item</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;

const BannerContainer = styled.div`
  background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.765) 15.08%,
      rgba(0, 0, 0, 0) 62.95%
    ),
    url(${GirlKidsLearning});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  height: 30vh;
`;
